import React, { useReducer } from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import {
  // BrowserRouter,
  Router
  // Route,
  // Switch,
  // Redirect
} from "react-router-dom";
import { MyContext } from "redux/Context.js";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

// pick a date util library
import DateFnsUtils from "@date-io/date-fns";
// import ReactPixel from "react-facebook-pixel";

// import Hidden from "@material-ui/core/Hidden";

import Dashboard from "container/layouts/DashboardContainer.js";

import { reducer, initialState } from "redux/reducer.js";
import { I18nextProvider } from "react-i18next";
import i18n from "language/i18next.js";
import enLocale from "date-fns/locale/en-US";
import itLocale from "date-fns/locale/it";

// import { PIXEL_ID } from "util/constants.js";

import config from "config/config.js";

import "assets/scss/material-dashboard-pro-react.scss?v=1.8.0";
import "assets/emma-shop.css";

const hist = createBrowserHistory();

// FB PIXEL
// if (PIXEL_ID) {
//   const advancedMatching = {}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
//   const options = {
//     autoConfig: true, // set pixel's autoConfig
//     debug: false // enable logs
//   };
//   ReactPixel.init(PIXEL_ID, advancedMatching, options);
//   ReactPixel.pageView();
// }

const localeMap = {
  en: enLocale,
  it: itLocale,
};

function App() {
  const [state, dispatch] = useReducer(
    (state, action) => reducer(action, state),
    initialState
  );

  const rootDiv = document.getElementById("root");
  const textFont = rootDiv.getAttribute("textFont");
  const titleFont = rootDiv.getAttribute("titleFont");
  const secondaryTitleFont = rootDiv.getAttribute("secondaryTitleFont");

  return (
    <I18nextProvider i18n={i18n}>
      <link
        href="https://fonts.googleapis.com/css2?family=Archivo+Narrow:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;500;562;600;700&family=Montserrat&display=swap"
        rel="stylesheet"
      />
      <link
        rel="stylesheet"
        href={`${config.cdn}fonticons/css/icons_v16.css`}
      />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"
      />
      <style>
        {textFont
          ? `
              *{
                font-family: ${textFont} !important;
                text-font: 20px !important
              }`
          : null}
        {titleFont
          ? `
              h1{
                font-family: ${titleFont} !important;
              }`
          : null}
        {secondaryTitleFont
          ? `
            h3{
              font-family: ${secondaryTitleFont} !important;
            }`
          : null}
        {`i{
          font-family: icons !important;
        }`}
      </style>
      <MyContext.Provider value={{ state, dispatch }}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[i18n?.language]}>
          <Router history={hist}>
            <Dashboard />
          </Router>
        </MuiPickersUtilsProvider>
      </MyContext.Provider>
    </I18nextProvider>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
